import { FlexRow } from '@/components/common/Flex';
import SettingsDivider from '@/components/settings/SettingsDivider';
import React, { FC, ReactNode } from 'react';
import { FlexCol } from '../common/Flex';
import LeftNavPageLayout from '../common/pageLayout/LeftNavPageLayout';
import PageSection from '../common/pageLayout/PageSection';
import { BigHeader, Paragraph } from '../common/Typography';

const SettingsLayout: FC<{
    title?: string;
    description?: string | React.ReactNode;
    children: ReactNode;
}> = ({ title, description, children }) => {
    return (
        <LeftNavPageLayout showInteractiveToolDisclosure={false}>
            <PageSection grow={1} mb={12}>
                <FlexRow justify="space-between">
                    <FlexCol flexGrow={1}>
                        <FlexCol>
                            {title && <BigHeader mb={6}>{title}</BigHeader>}
                            {description && (
                                <>
                                    <Paragraph fontSize="lg" color="gray.600">
                                        {description}
                                    </Paragraph>
                                    <SettingsDivider />
                                </>
                            )}
                            {children}
                        </FlexCol>
                    </FlexCol>
                </FlexRow>
            </PageSection>
        </LeftNavPageLayout>
    );
};

export default SettingsLayout;
